import {TranslationsManager} from "../utils/localisationManager";

export function doStyleAdvantages() {
    $(`
        <div class="index-content-wrapper container-index-advantages">
            <div class="content-wrapper-in">
                <main class="content">
                    <h2>${TranslationsManager.doGetStringByLang('ADVANTAGE_HEADER')}</h2>
                    <ul class="advantages advantages-detail clearfix">
<!--                        <li class="advantage advantage-1"><div><div class="img triangle"></div><div><strong>Nejkvalitnější materiály na trhu</strong><p>Lorem ipsum dolor sit amet, consecteruer adipiscing elit. Cras pede libero, dapibus.</p></div></li>-->
<!--                        <li class="advantage advantage-2"><div><div class="img cross"></div><div><strong>Střihy vyladěné do posledního detailu</strong><p>Lorem ipsum dolor sit amet, consecteruer adipiscing elit. Cras pede libero, dapibus.</p></div></li>-->
<!--                        <li class="advantage advantage-3"><div><div class="img circle"></div><div><strong>Unikátní autorské designy</strong><p>Lorem ipsum dolor sit amet, consecteruer adipiscing elit. Cras pede libero, dapibus.</p></div></li>-->
                    </ul>
                </main>
            </div>
        </div>
    `).insertAfter(".wide-carousel");

    $('.banner-wrapper img[alt="vyhoda"]').each(function (index, element) {
        $(element).closest('.banner').parent().removeClass('hidden').addClass('advantage').appendTo('.container-index-advantages .advantages');
    })

    $('.container-index-advantages .advantages .advantage .banner a').click(function (element) {
        element.preventDefault();
        element.stopPropagation();
    })
}
